import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
export const promotionsContextInitialData = {
    currentLanguage: 'en'
};
export const PromotionsContext = createContext(promotionsContextInitialData);
export const usePromotionsContext = () => {
    const { currentLanguage } = useContext(PromotionsContext);
    return { currentLanguage };
};
export const PromotionsProvider = ({ children, currentLanguage }) => {
    const value = useMemo(() => ({ currentLanguage }), [currentLanguage]);
    return (_jsx(PromotionsContext.Provider, { value: value, children: children }));
};
//# sourceMappingURL=promotions-context.js.map